import { render, staticRenderFns } from "./WetSignature.vue?vue&type=template&id=f8570ea0&"
import script from "./WetSignature.vue?vue&type=script&lang=js&"
export * from "./WetSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports